<div mat-dialog-content>
  <h2 mat-dialog-title>Figyelmeztetés</h2>
  <div>
    Tudomásul veszed, hogy az M30 letöltésének tényét rögzítjük,
     és a dokumentumot a törvényben meghatározott ideig őrizzük?
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="data" color="primary">Igen, letöltöm</button>
  <button mat-button [mat-dialog-close]="false">Nem, mégse</button>
</div>